module.exports = __webpack_public_path__ + "static/media/6 Cross Grip.07bc3992.jpg";